module.exports = __webpack_public_path__ + "img/itemImage.ee1dcd1f.png";